// extracted by mini-css-extract-plugin
export default {"localSection":"RvProfile_localSection__TjcIh"};